<template>
  <div
    v-if="props.isOpenList"
    class="settings-item"
  >
    <ComboBoxPrimary
      v-model.trim="newsFeedStore.filterTags.inputValue"
      label-key="name"
      :items="foundedTagList"
      :placeholder="t('settings_item.placeholder.search')"
      size="small"
      class="settings-item__combobox"
      @add-item="item => handleAddTag(item)"
    />
    <ul class="settings-item__list">
      <li
        v-for="tag in newsFeedStore.filterTags.list"
        :key="tag.id"
        class="settings-item__list-item"
      >
        <Chip @cancel="handleAddTag(tag)">
          <TagIcon />
          {{ tag.name }}
        </Chip>
      </li>
    </ul>
  </div>
</template>

<script setup>
import {computed, defineProps } from "vue";
import TagIcon from "@/components/Icons/TagIcon.vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { t } from "@/controllerLK/AvalLocalization";

const props = defineProps({
  isOpenList: {
    type: Boolean,
    default: false,
  }
});

const newsFeedStore = useNewsFeedStore();

// Вычисляемая функция. Проверка выбран ли тег.
const isTagSelected = computed(() => {
  return (item) => newsFeedStore.filterTags.list.some(tag => tag.id === item.id);
});

// Функция обработки добавления тега
const handleAddTag = async (item) => {
  if (isTagSelected.value(item)) {
    newsFeedStore.filterTags.list = newsFeedStore.filterTags.list.filter(tag => tag.id !== item.id);
    newsFeedStore.filterTags.listID = newsFeedStore.filterTags.listID.filter(tag => tag !== item.id);
  } else {
    newsFeedStore.filterTags.list.push(item);
    newsFeedStore.filterTags.listID.push(item.id);
  }

  newsFeedStore.clearNewsFeed();
  await newsFeedStore.getNews();
};

// Список тегов со значением поисковой строки (По началу/содержанию в алф. порядке)
const foundedTagList = computed(() => {
  const searchValue = newsFeedStore.filterTags.inputValue.toLowerCase();

  if (!searchValue) {
    return newsFeedStore.onFilterTags;
  }

  // Фильтруем теги, содержащие поисковую строку
  const filteredTags = newsFeedStore.onFilterTags.filter((item) =>
      item.name.toLowerCase().includes(searchValue)
  );

  // Разделяем на группы
  const startsWithQuery = [];
  const containsQuery = [];

  filteredTags.forEach((item) => {
    const lowerName = item.name.toLowerCase();
    const words = lowerName.split(" ");

    // Проверяем, начинается ли какое-то слово с поискового запроса
    const startsWithMatch = words.some(word => word.startsWith(searchValue));

    if (startsWithMatch) {
      startsWithQuery.push(item);
    } else {
      containsQuery.push(item);
    }
  });

  // Сортируем каждую группу по алфавиту
  const sortAlphabetically = (a, b) => a.name.localeCompare(b.name, "ru");

  startsWithQuery.sort(sortAlphabetically);
  containsQuery.sort(sortAlphabetically);

  // Объединяем группы
  return [...startsWithQuery, ...containsQuery];
});
</script>

<style lang="scss" scoped>
.settings-item {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__combobox {
    :deep(.combobox-wrapper) {
      background-color: #F7F8FD;
      border-radius: 8px;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
}
</style>